const baseUrl = process.env.REACT_APP_API_BASE_URL;

export interface JwtResult {
  token: string | null;
  error: string | null;
}

export async function fetchJwtToken(extractionID: string): Promise<JwtResult> {
  const url = `${baseUrl}/mock-digital-article/jwt/${encodeURIComponent(
    extractionID,
  )}`;

  try {
    const res = await fetch(url);

    if (res.status === 200) {
      const text = await res.text();

      try {
        const data = JSON.parse(text) as { token?: string };
        return { token: data.token ?? "", error: null };
      } catch {
        console.error("[fetchJwtToken] JSON parse error");
        return {
          token: null,
          error: "Invalid JSON response from server",
        };
      }
    }

    if (res.status === 500) {
      return { token: null, error: "Something went wrong." };
    }

    return {
      token: null,
      error: `Unexpected status: ${res.status}`,
    };
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : "Unexpected error";
    console.error("[fetchJwtToken] Fetch error");
    return { token: null, error: message };
  }
}
